import { render } from "./EditEmplacementModal.vue?vue&type=template&id=2641719c"
import script from "./EditEmplacementModal.vue?vue&type=script&lang=js"
export * from "./EditEmplacementModal.vue?vue&type=script&lang=js"

import "./EditEmplacementModal.vue?vue&type=style&index=0&id=2641719c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__